import { render, staticRenderFns } from "./ModalFormAccept.vue?vue&type=template&id=32193cc6&scoped=true&"
import script from "./ModalFormAccept.vue?vue&type=script&lang=js&"
export * from "./ModalFormAccept.vue?vue&type=script&lang=js&"
import style0 from "./ModalFormAccept.vue?vue&type=style&index=0&id=32193cc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32193cc6",
  null
  
)

export default component.exports